import Link from '@mui/material/Link';

export const dictionary = {
  header: {
    switchToDarkMode: 'Dark mode',
    switchToLightMode: 'Light mode',
  },

  auth: {
    login: {
      title: 'Login',

      buttonLogin: 'Login',
      buttonLoginWithGoogle: 'Login with Google',
      buttonLoginWithMicrosoft: 'Login with Microsoft',
      buttonLoginWithMeta: 'Login with Meta',
      buttonCreateAccount: 'Create account',
      buttonResetPassword: 'Reset password',
      dontHaveAccount: 'Don\'t have an account?',
      orLoginWithEmail: 'or login with email',
    },

    signUp: {
      title: 'Sign up',
      orSignUpWithEmail: 'or sign up with email',
      buttonSignup: 'Sign up',
      buttonSignupWithGoogle: 'Sign Up with Google',
      buttonSignupWithMicrosoft: 'Sign Up with Microsoft',
      buttonSignupWithMeta: 'Sign Up with Meta',
      buttonLogin: 'Login',
      alreadyHaveAccount: 'Already have an account?',
    },

    resetPassword: {
      title: 'Reset password',

      buttonLogin: 'Login',
      buttonReset: 'Reset password',

      passwordResetEmailSent: 'Password Reset Email Sent. Check your email for instructions.',
    },

    validations: {
      userWithThisEmailAlreadyExists: 'User with this email already exists',
      userNotFound: 'User not found',
      passwordsDoNotMatch: 'Passwords do not match',
      emailOrPasswordWrong: 'Email or password wrong',
      thePasswordMustBeAtLeast8CharactersLong: 'The password must be at least 8 characters long',
    },

    impersonate: {
      noToken: 'Token is not present',
      invalidToken: 'Token is invalid or expired',
    },

    firebase: {
      errors: {
        'auth/account-exists-with-different-credential': 'You used a different login provider before. Please try logging in with that provider.',
        'auth/account-exists-with-different-credential:facebook': 'You used a different login provider before, try logging in with google',
        'auth/account-exists-with-different-credential:google': 'You used a different login provider before, try logging in with facebook',
      },
    },
    divider: 'or',
  },

  users: {
    labelTypeCustomer: 'Customer',
    labelTypeAdmin: 'Admin',
    labelTypeStaff: 'Staff',

    invite: {
      dialog: {
        title: 'Invite team members',
        placeholderEmail: 'Email, comma separated',
        buttonInvite: 'Send invite',
        invitationSentInfo: (email: string) => `Invitation to ${email} sent`,
      },

      title: 'Team invitation',
      subtitle: (company?: string) => company ? `You've been invited to join ${company}'s team` : 'You\'ve been invited to join a team',
      buttonAcceptInvitation: 'Create account',
      inviteButton: 'Invite Team Member',
    },

    team: {
      title: 'Team',

      detailsLabel: 'Details',

      buttonInvite: 'Invite user',
    },

    create: {
      title: 'Create user',
      buttonCreate: 'Create user',
    },

    edit: {
      buttonEdit: 'Edit user',
      buttonDelete: 'Delete user',
      deleteConfirmation: 'Are you sure you want to delete this user?',
    },
  },

  menu: {
    auth: {
      login: 'Log In',
      logout: 'Log Out',
      signUp: 'Signup',
    },
    dashboard: 'Dashboard',
    home: 'Home',
    myTributes: 'My LGCYs',
    users: {
      list: 'Users',
      team: 'Team',
      myAccount: 'My account',
      create: 'Create user',
    },
    start: 'Start Here',
    faq: 'FAQ',
    help: 'Help',
  },

  forms: {
    fieldEmail: 'Email',
    fieldPhone: 'Phone',
    fieldPassword: 'Password',
    labelOptional: '(Optional)',
    buttonCreate: 'Create',
    buttonEdit: 'Save Changes',
    buttonDelete: 'Delete',

    signup: {
      fieldRepeatPassword: 'Repeat Password',
    },
    user: {
      fieldName: 'Name',
      fieldLastName: 'Last name',
      fieldType: 'Type',
      fieldCompany: 'Company',
      fieldPosition: 'Position',
      fieldPicture: 'Upload picture',
      fieldSurname: 'Family name',
      fieldEmailDisabledHelper: 'Please contact support to change the email.',
    },
    company: {
      fieldName: 'Name',
      fieldPrimaryContact: 'Primary Contact',
    },

    tributes: {
      petTypePlaceholder: 'Select',
      sexPlaceholder: 'Select',
      adoptionDate: 'Adoption/Birthday (optional)',
      passingDate: 'Passing Date (optional)',
      petNameToLong: 'Looks like the name is too long. Try using a shorter nickname for the card.',
    },

    validations: {
      required: 'This Field is Required',
      invalidDate: 'Date is Invalid',
      invalidEmail: 'Email is Invalid',
      invalidPhone: 'Phone number is Invalid',
      invalidYear: 'The year is incorrect',
      invalidPassword: 'Password is Invalid. At least 1 number is required.',
      invalidFileSize: (max: string) => `File is too big. Maximum is ${max}`,
      invalidFileType: 'File type is not valid',
      minLength: (length: number | string) => `Need to have at least ${length} characters`,
      maxLength: (length: number | string) => `Can't have more than ${length} characters`,
      oneOrMoreFieldsAreIncorrect: 'One or more fields are incorrect.',
      memberInvitationAllEmailsValid: 'One or more emails is invalid.',
      dateInFuture: 'Date cannot be in the future',
      dateTooOld: 'Date is too old',
      passingAfterBirth: 'Passing date must be after date of birth',
      onlySpaces: 'Should not contain only spaces',
    },
  },

  tributes: {
    create: {
      steps: {
        details: 'Pet Details',
        media: 'Media Upload',
        story: 'Build Timeline',
        order: 'Order Your LGCY Card',
        preview: 'Published',
      },
    },
    checkout: {
      validations: {
        promotionCodeInvalid: 'Promotion code is invalid',
      },
    },
    edit: {
      card: {
        title: 'Tap Into Their Memory, Anytime, Anywhere',
        subtitle: 'Hold their Journey of Love in Your Hand.',
        subtitle2nd: 'This premium, wallet-sized LGCY Card connects to a beautiful digital story through our Experience Engine\u2122 – no QR code, no app, just simple tap to relive their memories.',
        included: 'The image you select is more than a photo, it\'s a reminder of their love. With your premium LGCY Card Keepsake, one tap reconnects you to their Journey of Love anytime, anywhere.',
        premiumQuality: 'Premium Quality',
        noApp: 'No App Required',
        fastDelivery: 'Fast Delivery',
        durable: 'Durable, wallet-sized card with beautiful finish',
        workSeamlessly: 'Works seamlessly on all mobile devices',
        androidDevices: '*Android devices may require Tap&Pay turned on in settings',
        packaged: 'Carefully packaged and shipped to your door',
        freeShipping: 'Free shipping included',
        cardDialog: {
          title: 'Customize Your LGCY Card',
          chooseCard: 'Choose Your Card Image',
          chooseCardSubtitle: 'Select which photo you\'d like featured on your LGCY card',
          editCard: 'Position Your Image',
          editCardSubtitle: 'Drag to move and use buttons to zoom. The card area is shown below.',
          deliveryDetails: 'Delivery Address',
          deliveryDetailsSubtitle: 'Where should we send your LGCY card?',
          confirmation: 'Confirm Your Order',
          confirmationSubtitle: 'Review your LGCY card details',
          shippingTo: 'Shipping to:',
          totalPrice: 'Total: FREE',
          alreadyIncluded: 'Already included with your LGCY',
        },
      },
    },
  },

  filters: {
    fieldSearch: 'Search',
  },

  feedback: {
    changesSaved: 'Changes saved successfully',
  },

  dialogs: {
    defaultTitle: 'Are you sure you want to do this?',
    defaultContent: 'This action is irreversible.',
    buttonNo: 'No',
    buttonYes: 'Yes',
    buttonCancel: 'Cancel',
    buttonClose: 'Close',
  },

  errors: {
    noPagePermission: 'You are not allowed to view this page',
    somethingWentWrong: 'Something went wrong!',
  },

  routes: {

  },

  start: {
    title: 'Start Here',
    subtitle: 'A calm, guided experience to honor the companion who changed your life',
    steps: {
      1: {
        title: 'Create an account',
        subtitle: 'A simple, secure start to your journey',
      },
      2: {
        title: 'Share memories and photos',
        subtitle: 'Upload the moments that matter most',
      },
      3: {
        title: 'Review your Journey of Love',
        subtitle: 'See your memories come together beautifully',
      },
      4: {
        title: 'Publish your legacy',
        subtitle: 'Optionally order an NFC card keepsake',
      },
      5: {
        title: 'Share with loved ones',
        subtitle: 'Invite family and friends to remember together',
      },
    },
    cta: 'Start Your Journey',
    ctaExplainer: 'No pressure. Take all the time you need.',
  },

  faq: {
    generalInfo: {
      label: 'General Information',
      questions: [
        [
          'What is LGCYPet?',
          'LGCYPet is a company dedicated to creating personalized memorials for pets. We offer a variety of products such as engraved stones, photo frames, and keepsakes to help you honor and remember your beloved companion.',
        ],
        [
          'How can I contact LGCYPet?',
          <>Users can contact LGCYPet via the website contact form or by emailing <Link href="mailto:contact@digiamo.com">contact@digiamo.com</Link></>,
        ],
      ],
    },
    orderingProcess: {
      label: 'Ordering Process',
      questions: [
        [
          'How do I place an order?',
          'Users place an order by selecting a product on the website, customizing it using the online tool, and completing checkout.',
        ],
        [
          'Can I preview my customized product before purchasing?',
          'Yes, users can see a real-time preview of their customized product before checkout.',
        ],
        [
          'What payment methods are accepted?',
          'Accepted payment methods include major credit cards (Visa, MasterCard, American Express) and PayPal.',
        ],
      ],
    },
    customization: {
      label: 'Customization',
      questions: [
        [
          'What customization options are available?',
          'Customization options include photos, names, dates, personal messages, font selection, sizing, and placement.',
        ],
        [
          'Can I make changes after placing an order?',
          'Changes can be made within 24 hours of placing an order by contacting customer service.',
        ],
      ],
    },
    shippingAndDelivery: {
      label: 'Shipping and Delivery',
      questions: [
        [
          'How long does it take to receive my order?',
          'Production typically takes 7–10 business days, followed by 3–5 business days for shipping. Expedited shipping may be available.',
        ],
        [
          'Do you ship internationally?',
          'Yes, international shipping is supported, with timelines and costs varying by destination.',
        ],
        [
          'How can I track my order?',
          'Users receive a tracking number via email once the order ships.',
        ],
      ],
    },
    returnsAndRefunds: {
      label: 'Returns and Refunds',
      questions: [
        [
          'What is your return policy?',
          'A 100% satisfaction guarantee is offered. Products can be returned within 30 days for a refund or replacement, subject to conditions for custom items.',
        ],
        [
          'How do I return a product?',
          'Users must contact customer service to initiate a return and receive instructions.',
        ],
        [
          'When will I receive my refund?',
          'Refunds are processed within 5–7 business days after the returned item is received.',
        ],
      ],
    },
    productsAndMaterials: {
      label: 'Products and Materials',
      questions: [
        [
          'What materials are used?',
          'Products use materials such as natural stone, durable acrylic, and premium wood.',
        ],
        [
          'Are materials eco-friendly?',
          'LGCYPet strives to use eco-friendly materials and sustainable processes where possible.',
        ],
      ],
    },
    additionalServices: {
      label: 'Additional Services',
      questions: [
        [
          'Do you offer gift cards?',
          'Yes, gift cards are available in various denominations.',
        ],
        [
          'Can I order a custom product not listed?',
          'Custom requests can be made by contacting customer service.',
        ],
      ],
    },
    communityAndSupport: {
      label: 'Community and Support',
      questions: [
        [
          'Is there a community for pet owners?',
          'Yes, LGCYPet offers an online community where pet owners can share stories and support one another.',
        ],
        [
          'How can I share my experience?',
          'Users are encouraged to share feedback via reviews, social media, or the website.',
        ],
      ],
    },
  },

  countries: {
    US: 'United States',
    AF: 'Afghanistan',
    AX: 'Aland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua And Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia And Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, Democratic Republic of the',
    CK: 'Cook Islands',
    CR: 'CostaRica',
    CI: 'Cote d\'Ivoire',
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curacao',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'GuineaBissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and McDonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'IsleOfMan',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KR: 'Korea, Republic of',
    KP: 'Korea, Democratic People\'s Republic of',
    XK: 'Kosovo',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Lao People\'s Democratic Republic',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'NewCaledonia',
    NZ: 'NewZealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana  Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine, State of',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthelemy',
    SH: 'Saint Helena',
    KN: 'Saint Kitts And Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin',
    PM: 'Saint Pierre And Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'SaudiArabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'SouthAfrica',
    GS: 'South Georgia and the South Sandwich Islands',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'TimorLeste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'British Virgin Islands',
    VI: 'US Virgin Islands',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
};

export default dictionary;
